package com.gstechnovos.sanative.pages

import androidx.compose.runtime.Composable
import com.gstechnovos.sanative.components.widgets.styles.MaintenanceButtonStyle
import com.gstechnovos.sanative.utils.LocalBreakpoint
import com.gstechnovos.sanative.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

//@Page("/maintenance")
@Composable
fun MaintenancePage() {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.MD

    Box(
        modifier = Modifier
            .fillMaxSize()
            .minHeight(100.vh)
            .padding(16.px)
            .styleModifier {
                property("background-image", "url('${Res.Images.Maintenance.MAINTENANCE_COVER}')")
                property("background-size", "cover")
                property("background-position", "center")
                property("background-repeat", "no-repeat")
            },
        contentAlignment = Alignment.Center
    ) {
        // 2. The Upgraded Bento Container
        Box(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(16.px)
                // Crisp neuro-safe border around the whole card
                .border(1.px, LineStyle.Solid, Color.rgb(0xE2E8F0))
                // UPGRADE 1: Clinical top accent bar
                .borderTop(6.px, LineStyle.Solid, Color.rgb(0x008080))
                // UPGRADE 2: Ultra-soft, 5% ambient depth (WCAG safe)
                .boxShadow(0.px, 12.px, 32.px, 0.px, Color.rgba(0, 0, 0, 0.05f))
                .maxWidth(600.px)
                .width(100.percent)
                .padding(topBottom = if (isDesktop) 56.px else 48.px, leftRight = if (isDesktop) 48.px else 24.px)
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                // UPGRADE 3: Visual Anchor / Icon Container
                Box(
                    modifier = Modifier
                        .size(86.px)
                        .backgroundColor(Color.rgb(0x008080).copyf(alpha = 0.1f))
                        .borderRadius(50.percent)
                        .margin(bottom = 24.px),
                    contentAlignment = Alignment.Center
                ) {
                    // You can replace LOGO_MARK with any icon you prefer (e.g., an alert or wrench)
                    Image(
                        src = Res.Images.ICON,
                        modifier = Modifier.size(64.px)
                    )
                }

                SpanText(
                    text = "UNDER MAINTENANCE",
                    modifier = Modifier
                        .color(Color.rgb(0x008080))
                        .fontSize(20.px) // Slightly smaller for better hierarchy
                        .fontWeight(FontWeight.Bold)
                        .letterSpacing(2.px) // Increased tracking for a modern look
                        .margin(bottom = 12.px)
                        .textAlign(TextAlign.Center)
                )

                SpanText(
                    text = "We're enhancing our website to better serve you.",
                    modifier = Modifier
                        .color(Color.rgb(0x111827))
                        .fontSize(if (isDesktop) 36.px else 28.px) // Refined sizing
                        .fontWeight(FontWeight.ExtraBold) // Heavier weight for impact
                        .lineHeight(1.2)
                        .margin(bottom = 24.px)
                        .textAlign(TextAlign.Center)
                )

                SpanText(
                    text = "Thank you for your patience. We'll be back online shortly with improved features and content.",
                    modifier = Modifier
                        .color(Color.rgb(0x4B5563))
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Medium)
                        .lineHeight(1.6)
                        .margin(bottom = 40.px)
                        .textAlign(TextAlign.Center)
                )

                Link(
                    path = Res.Strings.Links.EMAIL,
                    text = Res.Strings.Buttons.CONTACT_CLINIC,
                    modifier = MaintenanceButtonStyle.toModifier()
                )
            }
        }
    }
}